import merge from 'lodash.merge';
export function configReducer(state, action) {
    return merge({}, state, action);
}
//# sourceMappingURL=reducer.js.map